var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classValue,attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":['HomePage','Learn']}},[_c('router-view')],1),_vm._v(" "),_c('div',{staticClass:"statis",domProps:{"innerHTML":_vm._s(_vm.statis)}}),_vm._v(" "),_c('div',{staticClass:"baidu"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30a8e86a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 